import React from "react"
import SbEditable from "storyblok-react"

import Components from "../components/components.js"

import { PageOverview } from "gatsby-theme-gba"

const PageOverviewEditable = ({ blok }) => (
  <SbEditable content={blok}>
    <PageOverview heading={blok.headline}>
      {blok.bigPageTeaser &&
        blok.bigPageTeaser.map(innerBlok => {
          let content = innerBlok
          content.date = ""
          content.tagList = []
          content.link = innerBlok.link.cached_url || "/"
          if (innerBlok.link.linktype === "story") {
            content.link =
              innerBlok.link.story && innerBlok.link.story.full_slug
                ? innerBlok.link.story.full_slug
                : content.link
          }
          content.currentLanguage = blok.currentLanguage
          content.seoLinks = blok.seoLinks
          const component = React.createElement(Components(content.component), {
            key: content._uid,
            blok: content,
          })
          return component
        })}
    </PageOverview>
  </SbEditable>
)

export default PageOverviewEditable
